import * as React from 'react';
import AdvertisingOptionFull from './components/AdvertisingOptionFull';
import commit from './orchestration/commit';
import reset from './orchestration/reset';
import { Option } from 'owa-options-core';
import { isFeatureEnabled } from 'owa-feature-flags';
import isDirty from './selectors/isDirty';
import { isGdprAdMarket, areAdsEnabled } from 'owa-mail-ads-shared';

let AdvertisingOption: Option = {
    key: 'advertising_options',
    titleStringKey: 'optionTitle_ads',
    searchTermsStringKey: 'optionTitle_ads',
    hideTitleInFullOptions: true,
    fullOptionFormSettings: {
        render: () => <AdvertisingOptionFull />,
        isDirty: isDirty,
        onSave: commit,
        onDiscard: reset,
    },
    isHidden: () => !(isFeatureEnabled('fwk-gdprAdsPrefs') && isGdprAdMarket() && areAdsEnabled()),
    allowedOptionKeys: ['ManageAdGdprPreference'],
};

export default AdvertisingOption;
